import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useIsMobile } from "../hooks/use-is-mobile";
import { MobilePillTabs } from "./mobile/mobile-pill-tabs";

export const CustomTabs = ({ currentTab, setCurrentTab, tabsData, style, indicatorColor }) => {
  const isMobile = useIsMobile();
  const handleTabChange = React.useCallback(
    (event, value) => {
      setCurrentTab(value)
    },
    [setCurrentTab]
  )

  if (isMobile) {
    return (
      <MobilePillTabs
        tabs={tabsData}
        value={currentTab}
        onChange={(item) => setCurrentTab(item.value)}
      />
    );
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: '#bfbfbf' }}>
      <Tabs
        onChange={handleTabChange}
        value={currentTab}
        variant='scrollable'
        scrollButtons="auto"
        indicatorColor={indicatorColor}
      >
        {tabsData.map((item, index) => {

          return (
            <Tab
              key={index}
              label={item.label}
              value={item.value}
              sx={{
                ...(currentTab === item.value && style)
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
